export default {
  getSaltBin: (state) => state.saltBin,
};
